import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, AfterViewInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalClickService } from '../../services/global-click/global-click.service';
declare var $: any;

export class SelectOption {
  value: any;
  text: any;
  isDefault?: boolean;
  disabled?: boolean = false;
  extraData?: any;
}

@Component({
  selector: 'teiasoft-select',
  templateUrl: './teiasoft-select.component.html',
  styleUrls: ['./teiasoft-select.component.scss']
})

export class TeiasoftSelectComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  private readonly closeOnScrollHandler = () => {
    if (!this.optOpened) return;
    this.closeAllSelect(true);
  };

  @Input() labelText: string = "";
  @Input() isRequired: boolean = false;
  @Input() isValid: boolean = true;
  @Input() readOnly: boolean = false;
  @Input() optionsList: SelectOption[] = new Array();
  @Input() defaultValue: any;
  @Input() disabled: boolean = false;
  @Input() spaceLabel: boolean = false;
  @Input() noMinWidth: boolean = false;
  @Input() isMobile: boolean = false;
  @Input() size: string = '';
  @Input() clearValue: boolean = false;
  @Input() filterVersion: boolean = false;
  @Input() rootTranslate: string = "";
  @Input() autoComplete: boolean = false;
  @Input() tabIndex: number = -1;
  @Input() removeFixedFromOptCnt: boolean = false;
  @Input() disableOptionSort: boolean = false;
  @Input() emitOnDefaultInit: boolean = true;
  @Output() onSelected: EventEmitter<SelectOption> = new EventEmitter();

  optOpened: boolean = false;
  optionId: string = "";
  selectId: string = "";
  defaultText: string = "";
  optionsW: number = 0;
  optionsTop: number = 0;
  optionsLeft: number = 0;
  acVisible: boolean = false;
  filteredList: SelectOption[] = new Array();
  hoverIndex: number = -1;
  inputReadonly: boolean = false;

  clickListener!: (evt: any) => void;
  pointerDownInsideSelect: boolean = false;

  @ViewChild('inputWrapper') inputWrapper!: ElementRef;


  constructor(private translate: TranslateService, private globalClickService: GlobalClickService) {
    this.globalClickService.registerComponent(this);
  }


  ngOnInit(): void {
    this.manageSelectId();
    this.manageOptCntId();
    document.addEventListener('teiasoft-close-floating-dropdowns', this.closeOnScrollHandler);
  }


  ngOnDestroy(): void {
    document.removeEventListener('teiasoft-close-floating-dropdowns', this.closeOnScrollHandler);
    this.globalClickService.unregisterComponent(this);
    this.removeIdFromSessionStorage("TS-SELECT-LIST", this.selectId);
    this.removeIdFromSessionStorage("TS-OPTION-LIST", this.optionId);
  }

  ngAfterViewInit(): void {

  }

  handleClickOutside(event: Event) {
    const target = event.target as HTMLElement | null;
    if (!target) return;

    const selectEl = document.getElementById(this.selectId);
    if (selectEl && selectEl.contains(target)) return;

    const optionsEl = document.getElementById(this.optionId);
    if (optionsEl && optionsEl.contains(target)) return;

    this.closeAllSelect(true);
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["optionsList"]) {
      this.optionsList = new Array();
      this.filteredList = new Array();
      this.optionsList = changes["optionsList"].currentValue;
      this.filteredList = changes["optionsList"].currentValue;
      this.sortOptionsList();
      this.syncDefaultTextFromCurrentValue();
      this.syncFilterSelectValue();
    }

    if (changes && changes["defaultValue"]) {
      if (changes["defaultValue"].currentValue == undefined || changes["defaultValue"].currentValue == null) {
        this.defaultValue = '';
        this.defaultText = '';
        this.syncFilterSelectValue();
        return;
      }
      this.defaultValue = changes["defaultValue"].currentValue;
      this.syncDefaultTextFromCurrentValue();
      this.syncFilterSelectValue();

      // Keep legacy behavior by default: emit only on first binding of defaultValue.
      // Emitting only once prevents repeated parent<->child feedback loops.
      if (this.emitOnDefaultInit && changes["defaultValue"].firstChange) {
        let _opt: SelectOption = new SelectOption();
        _opt = this.optionsList!.find(x => this.areValuesEquivalent(x?.value, this.defaultValue))!;
        if (_opt) this.onSelected.emit(_opt);
      }
    }

    if (changes && changes["clearValue"]) {
      this.clearValue = changes["clearValue"].currentValue;
      if (this.clearValue) {
        if (this.filterVersion == false) {
          let _elem: HTMLInputElement = $('#' + this.selectId).children().children()[0];
          //let _elem: any = document.getElementById(this.selectId)!;
          if (_elem) {
            _elem.value = ''; //["value"] = '';
          }
        } else {
          let _elem: HTMLSelectElement = document.getElementById('sel_' + this.selectId)! as HTMLSelectElement;
          if (_elem) {
            _elem.selectedIndex = -1;
            _elem.value;
          }
        }
        this.defaultValue = '';
        this.defaultText = '';
        this.syncFilterSelectValue();
      } else {
        this.syncFilterSelectValue();
      }
    }

    if (changes && changes["tabIndex"]) {
      this.tabIndex = changes["tabIndex"].currentValue;
      if (this.tabIndex == 0 && !this.disabled) setTimeout(() => $('.tab-0').focus(), 250);
    }

    if (changes && changes["readOnly"]) {
      this.readOnly = changes["readOnly"].currentValue;
    }

    if (changes && changes["disabled"]) {
      this.disabled = changes["disabled"].currentValue;
      if (this.disabled) this.closeAllSelect(true);
    }
  }

  sortOptionsList() {
    if (this.disableOptionSort)
      return;
    this.optionsList = this.optionsList.sort((a, b) => a.text?.localeCompare(b.text));
  }

  getRandomInt(min: number, max: number): number {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  private removeIdFromSessionStorage(storageKey: string, id: string): void {
    if (!id) {
      return;
    }

    const stored = sessionStorage.getItem(storageKey);
    if (!stored) {
      return;
    }

    const updated = stored.split(',').filter(item => item && item !== id);
    if (updated.length > 0) {
      sessionStorage.setItem(storageKey, updated.join(','));
    } else {
      sessionStorage.removeItem(storageKey);
    }
  }

  manageSelectId() {
    let _list: string[] = new Array();
    if (sessionStorage.getItem("TS-SELECT-LIST")) {
      _list = sessionStorage.getItem("TS-SELECT-LIST")!.split(",");
      if (_list.length == 999999) {
        _list = new Array();
        sessionStorage.removeItem("TS-SELECT-LIST");
      }
    }
    let x = this.getRandomInt(0, 999999);
    if (_list && _list.length > 0) {
      while (_list.findIndex(t => t == "TS_" + x.toString()) != -1) {
        let x = this.getRandomInt(0, 999999);
        if (_list.findIndex(t => t == "TS_" + x.toString()) == -1) break;
      }
    } else {
      _list = new Array();
    }
    _list.push("TS_" + x.toString());
    sessionStorage.setItem("TS-SELECT-LIST", _list.join(","));
    this.selectId = "TS_" + x.toString();
  }

  manageOptCntId() {
    let _list: string[] = new Array();
    if (sessionStorage.getItem("TS-OPTION-LIST")) {
      _list = sessionStorage.getItem("TS-OPTION-LIST")!.split(",");
      if (_list.length == 999999) {
        _list = new Array();
        sessionStorage.removeItem("TS-OPTION-LIST");
      }
    }
    let x = this.getRandomInt(0, 999999);
    if (_list && _list.length > 0) {
      while (_list.findIndex(t => t == "TSOPT_" + x.toString()) != -1) {
        let x = this.getRandomInt(0, 999999);
        if (_list.findIndex(t => t == "TSOPT_" + x.toString()) == -1) break;
      }
    } else {
      _list = new Array();
    }
    _list.push("TSOPT_" + x.toString());
    sessionStorage.setItem("TS-OPTION-LIST", _list.join(","));
    this.optionId = "TSOPT_" + x.toString();
  }

  filterAutoDataSet() {

  }

  /* EVENTS */
  onSelectPointerDown() {
    this.pointerDownInsideSelect = true;
    setTimeout(() => this.pointerDownInsideSelect = false, 250);
  }

  onOpenCloseOptions(evt: any) {
    if (this.filterVersion) return;
    if (this.disabled) return;
    if (this.readOnly) return;

    const isFocusEvent = evt == 'focus';

    if (isFocusEvent) {
      if (this.pointerDownInsideSelect) return;
      this.openOptions();
      return;
    }

    this.closeAllSelect(false);
    // if (this.defaultValue != undefined && this.defaultValue != '' && evt == 'focus') return; // Se arrivo con tab

    this.optOpened = !this.optOpened;
    if (this.optOpened) {
      this.showOptions();
    } else {
      document.getElementById(this.optionId)!.style.display = "none";
    }

  }

  private showOptions(scrollToSelected: boolean = true) {
    const rect = this.inputWrapper.nativeElement.getBoundingClientRect();
    const computedStyle = window.getComputedStyle(this.inputWrapper.nativeElement);

    const borderLeftWidth = parseFloat(computedStyle.borderLeftWidth);
    const borderRightWidth = parseFloat(computedStyle.borderRightWidth);
    const contentWidth = rect.width - borderLeftWidth - borderRightWidth;

    this.optionsTop = rect.bottom;
    this.optionsLeft = rect.left;
    this.optionsW = contentWidth;

    document.getElementById(this.optionId)!.style.display = "block";

    if (scrollToSelected) {
      this.setHoverIndexOnSelectedOption();
      this.scrollToSelectedOption();
    }
  }

  private openOptions(scrollToSelected: boolean = true) {
    this.closeAllSelect(false);
    if (this.optOpened) return;
    this.optOpened = true;
    this.showOptions(scrollToSelected);
  }

  closeAllSelect(alsoMe: boolean) {
    if (sessionStorage.getItem("TS-OPTION-LIST") == null || sessionStorage.getItem("TS-OPTION-LIST") == undefined) return;
    let _list: string[] = new Array();
    _list = sessionStorage.getItem("TS-OPTION-LIST")!.split(',');
    for (var x = 0; x < _list.length; x++) {
      if (_list[x] != this.optionId) {
        if (document.getElementById(_list[x]) != null)
          document.getElementById(_list[x])!.style.display = "none";
      } else {
        if (alsoMe) {
          this.optOpened = false;
          if (document.getElementById(_list[x]) != null)
            document.getElementById(_list[x])!.style.display = "none";
        }
      }
    }
  }

  onModelChange(val: any) {
    const selected = this.optionsList.find(x => x.value === val);
    if (selected) {
      this.defaultText = selected.text;
      this.onSelected.emit(selected);
    } else {
      this.defaultText = '';
    }
  }

  selectThis(evt: any, from: string) {
    if (this.disabled || evt.disabled) return;
    if (this.filterVersion) {
      let _value: any = evt.target.value;
      let _opt: SelectOption = new SelectOption();
      if (_value.toString() != '') {
        if (typeof this.optionsList[this.optionsList.length - 1].value == 'boolean') {
          _value = evt.target.value == 'true' ? true : false;
        }
        this.defaultValue = _value;
        _opt = this.optionsList!.find(x => x.value.toString() == this.defaultValue.toString())!;
      }

      // GBR 28/02/2024 PER TAB
      //this.optOpened = false;
      this.onOpenCloseOptions('selection');
      // END
      this.onSelected.emit(_opt);
    } else {
      // GBR 05/03/2024 - MQBF-22
      this.defaultValue = evt.value;
      this.defaultText = evt.text;

      // GBR 28/02/2024 PER TAB
      //this.optOpened = false;
      //document.getElementById(this.optionId)!.style.display="none";
      if (from == 'enter') this.onOpenCloseOptions('selection');
      else this.closeAllSelect(true);
      // END
      this.onSelected.emit(evt);
    }

    // GBR 05/03/2024 - MQBF-22
    // Riporto la lista all'orignale
    this.filteredList = new Array();
    this.filteredList = JSON.parse(JSON.stringify(this.optionsList));
  }

  onInputChange(evt: any) {
    //if (this.autoComplete){
    let _value = evt.target.value;
    this.filteredList = [
      // Options that start with the value
      ...this.optionsList.filter(x => x.text.toLowerCase().startsWith(_value.toLowerCase())).sort((a, b) => a.text!.localeCompare(b.text!)),
      // Options that contain the value but don't start with it
      ...this.optionsList.filter(x =>
        x.text.toLowerCase().indexOf(_value.toLowerCase()) !== -1 &&
        !x.text.toLowerCase().startsWith(_value.toLowerCase())
      ).sort((a, b) => a.text!.localeCompare(b.text!))
    ];
    this.hoverIndex = 0;

    // GBR 05/03/2024 - MQBF-22 - Se è chiuso apro l'option list
    if (!this.optOpened) this.openOptions(false);

    // GBR 05/03/2024 - MQBF-22 SE Non ho risultati passo la optionlist orginale
    // MQF-485: DEPRECATED
    // if (this.filteredList.length == 0){
    //   this.filteredList = JSON.parse(JSON.stringify(this.optionsList));
    //   this.hoverIndex = -1;
    // }

    // GBR 21/03/2024 MQF-155
    // SE HO SBIANCATO EMITTO VALORE VUOTO
    // if (_value == ''){
    //   let _evt:SelectOption = new SelectOption();
    //   _evt.text = '';
    //   _evt.value = '';
    //   this.onSelected.emit(_evt);
    // }
    //} 
  }

  onKeyDown(evt: any) {
    // Tab
    if (evt.keyCode == 9) {
      if (this.optOpened)
        this.onOpenCloseOptions(null);
    }

    // Arrow UP
    if (evt.keyCode == 38) {
      if (!this.optOpened) return;
      if (this.hoverIndex == 0) return;
      for (var x = 0; x < this.filteredList.length; x++) {
        $('#ts_ac_row_' + x).removeClass("ac-row-selected");
      }
      $('#ts_ac_row_' + this.hoverIndex).addClass("ac-row-selected");
      this.hoverIndex--;
      let _scroll: number = this.autoComplete ? $('.ts-select-scroll').scrollTop() : $("#" + this.optionId).scrollTop();
      let _acRowH: number = $('.ts-option-row').height();
      let _acCntH: number = $("#" + this.optionId).height();
      let _acInputH: number = this.autoComplete ? $('.ts-input-ac').height() : 0;
      if (_scroll > (_acRowH * this.hoverIndex)) {
        this.autoComplete ? $('.ts-select-scroll').scrollTop(_scroll - Math.round(_acRowH)) : $("#" + this.optionId).scrollTop(_scroll - Math.round(_acRowH));
      }

    }

    // Arrow DOWN
    if (evt.keyCode == 40) {
      if (!this.optOpened) return;
      if (this.hoverIndex == this.filteredList.length - 1) return;
      for (var x = 0; x < this.filteredList.length; x++) {
        $('#ts_ac_row_' + x).removeClass("ac-row-selected");
      }
      $('#ts_ac_row_' + this.hoverIndex).addClass("ac-row-selected");
      this.hoverIndex++;
      let _scroll: number = this.autoComplete ? $('.ts-select-scroll').scrollTop() : $("#" + this.optionId).scrollTop();
      let _acRowH: number = $('.ts-option-row').height();
      let _acCntH: number = $("#" + this.optionId).height();
      let _acInputH: number = this.autoComplete ? $('.ts-input-ac').height() : 0;
      if ((_acRowH * this.hoverIndex) > (_acCntH - _acRowH)) {
        this.autoComplete ? $('.ts-select-scroll').scrollTop(_scroll + Math.round(_acRowH) + _acInputH) : $("#" + this.optionId).scrollTop(_scroll + Math.round(_acRowH));
      }
    }

    /* ENTER */
    if (evt.keyCode == 13) {
      if (this.optOpened) {
        this.selectThis(this.filteredList[this.hoverIndex], "enter");
      } else {
        this.inputReadonly = false;
        this.onOpenCloseOptions(null);
      }
    }
  }

  onFocusOut(evt: any) {
    setTimeout(() => {
      const inputValue: string = evt.target.value;
      const previousValue = this.defaultValue;
      const previousText = this.defaultText;

      // Check if the input value matches a valid option
      const matchedIndex: number = this.optionsList.findIndex(option => option.text === inputValue);
      if (matchedIndex === -1) {

        /* MP: REMOVED because we agree the default behavior should be to clean the field when no options is matching the input text
        // Invalid input: Restore the last valid option
        // const previousValidOption = this.optionsList.find(option => option.value === this.defaultValue);
        // this.defaultText = previousValidOption ? previousValidOption.text : '';
        // evt.target.value = this.defaultText; // Update the input field value
        */
        const noMatch = new SelectOption();
        noMatch.value = null;
        noMatch.text = '';

        const valueChanged = !this.areValuesEquivalent(previousValue, noMatch.value);
        const textChanged = previousText !== noMatch.text;

        this.defaultValue = noMatch.value;
        this.defaultText = noMatch.text;

        if (valueChanged || textChanged) {
          this.onSelected.emit(noMatch);
        }
      } else {
        // Valid input: Update defaultValue and defaultText
        const matchedOption = this.optionsList[matchedIndex];

        const valueChanged = !this.areValuesEquivalent(previousValue, matchedOption.value);
        const textChanged = previousText !== matchedOption.text;

        this.defaultValue = matchedOption.value;
        this.defaultText = matchedOption.text;

        if (valueChanged || textChanged) {
          this.onSelected.emit(matchedOption);
        }
      }

      this.filteredList = [...this.optionsList]; // Reset filteredList
      this.hoverIndex = -1;
    }, 200); // Delay to prevent interference with selection
  }

  private areValuesEquivalent(valueA: any, valueB: any): boolean {
    if (valueA === valueB) return true;
    if (valueA == null || valueB == null) return false;

    if (typeof valueA === 'object' || typeof valueB === 'object') return false;

    return valueA.toString() === valueB.toString();
  }

  isSelectedOption(option: SelectOption): boolean {
    return this.areValuesEquivalent(option?.value, this.defaultValue);
  }

  private getSelectedOptionIndex(): number {
    return this.filteredList.findIndex(option => this.isSelectedOption(option));
  }

  private setHoverIndexOnSelectedOption(): void {
    const selectedIndex = this.getSelectedOptionIndex();
    this.hoverIndex = selectedIndex != -1
      ? selectedIndex
      : (this.filteredList.length > 0 ? 0 : -1);
  }

  private scrollToSelectedOption(): void {
    const selectedIndex = this.getSelectedOptionIndex();
    if (selectedIndex == -1) return;

    setTimeout(() => {
      const optionsEl = document.getElementById(this.optionId);
      const optionRows = optionsEl?.querySelectorAll<HTMLElement>('.ts-option-row');
      const selectedRow = optionRows?.[selectedIndex];
      if (!optionsEl || !selectedRow) return;

      const rowTop = selectedRow.offsetTop;
      const rowBottom = rowTop + selectedRow.offsetHeight;
      const visibleTop = optionsEl.scrollTop;
      const visibleBottom = visibleTop + optionsEl.clientHeight;

      if (rowTop < visibleTop) {
        optionsEl.scrollTop = rowTop;
      } else if (rowBottom > visibleBottom) {
        optionsEl.scrollTop = rowBottom - optionsEl.clientHeight;
      }
    });
  }

  private syncDefaultTextFromCurrentValue(): void {
    if (this.defaultValue == undefined || this.defaultValue == null || this.defaultValue.toString().length == 0) {
      this.defaultText = '';
      return;
    }

    const selected = this.optionsList.find(x => this.areValuesEquivalent(x?.value, this.defaultValue));
    if (selected) {
      this.defaultText = selected.text;
      return;
    }

    if (this.rootTranslate != '') {
      this.defaultText = this.translate.instant(this.rootTranslate + "." + this.defaultValue);
      return;
    }

    this.defaultText = '';
  }

  private syncFilterSelectValue(): void {
    if (!this.filterVersion) return;
    if (!this.selectId) return;

    setTimeout(() => {
      const selectEl = document.getElementById('sel_' + this.selectId) as HTMLSelectElement | null;
      if (!selectEl) return;

      const desiredValue = this.defaultValue != null ? this.defaultValue.toString() : '';
      const hasDesiredValue = Array.from(selectEl.options).some(opt => opt.value.toString() == desiredValue);

      if (hasDesiredValue) selectEl.value = desiredValue;
      else if (selectEl.options.length > 0) selectEl.value = selectEl.options[0].value;
      else selectEl.value = '';
    });
  }

  //if (this.optOpened) this.onOpenCloseOptions('focusout');
}
